module.exports = __webpack_public_path__ + "media/32.398c621a.mp3";